<template>
  <div class="module-access">
    <div class="campus">小程序管理 &gt; 教材模块权限</div>
    <el-card>
      <el-alert v-if="!enabled" title="权限管理尚未开放" type="info" :closable="false" />
      <template v-else>
        <el-form inline>
          <el-form-item label="小程序">
            <el-select v-model="miniid" :disabled="saving" filterable placeholder="选择可管理的小程序" @change="changeMini">
              <el-option v-for="mini in minis" :key="mini.id" :label="mini.name" :value="mini.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="教材">
            <el-select v-model="bookid" :disabled="saving || !miniid" filterable clearable placeholder="选择教材查看例外" @change="loadState">
              <el-option v-for="book in books" :key="book.bookId" :label="book.name + '（' + book.bookId + '）'" :value="book.bookId" />
            </el-select>
          </el-form-item>
          <el-button :disabled="!miniid || saving" @click="loadState">刷新</el-button>
        </el-form>
        <div v-loading="loading">
          <el-alert v-if="denied" title="没有该小程序的模块权限" type="error" :closable="false" />
          <template v-if="miniid">
          <p>类型默认作用于当前小程序的所有使用机构；教材例外是否生效由类型规则控制。其他小程序的配置独立生效。</p>
          <el-table :data="typeRows">
            <el-table-column label="类型"><template slot-scope="scope">{{ typeName(scope.row.code) }}</template></el-table-column>
            <el-table-column label="默认权限"><template slot-scope="scope">{{ scope.row.rule ? modeName(scope.row.rule.accessMode) : '未配置，沿用原配置' }}</template></el-table-column>
            <el-table-column label="试用"><template slot-scope="scope">{{ scope.row.rule && scope.row.rule.trialEnabled === 1 ? '允许已标记的试用内容' : '不单独开放试用' }}</template></el-table-column>
            <el-table-column label="适用版本"><template slot-scope="scope">{{ scope.row.rule ? effectName(scope.row.rule.v1Effect) : '原有版本' }}</template></el-table-column>
            <el-table-column label="教材例外"><template slot-scope="scope">{{ scope.row.rule ? (scope.row.rule.enforced === 1 ? '不允许，统一使用类型规则' : '允许') : '未配置' }}</template></el-table-column>
            <el-table-column label="操作"><template slot-scope="scope"><el-button type="text" :disabled="!editable || saving" @click="editType(scope.row)">配置默认</el-button></template></el-table-column>
          </el-table>
          <h3>教材模块例外与实际生效权限</h3>
          <el-table :data="modules" empty-text="请选择教材">
            <el-table-column prop="name" label="模块" />
            <el-table-column prop="id" label="模块编号" width="100" />
            <el-table-column label="归类"><template slot-scope="scope">{{ scope.row.moduleCode ? typeName(scope.row.moduleCode) : (scope.row.pendingReason || '尚未归类') }}</template></el-table-column>
            <el-table-column label="实际权限"><template slot-scope="scope">{{ scope.row.policy ? modeName(scope.row.policy.mode) : '沿用原配置' }}</template></el-table-column>
            <el-table-column label="生效来源"><template slot-scope="scope">{{ scope.row.policy ? sourceName(scope.row.policy.source) : '原配置' }}</template></el-table-column>
            <el-table-column label="操作" width="200"><template slot-scope="scope">
              <el-button type="text" :disabled="!editable || !scope.row.supported || saving" @click="editModule(scope.row)">{{ scope.row.policy ? '配置例外' : '归类并配置' }}</el-button>
              <el-button type="text" :disabled="!editable || !hasException(scope.row.id) || saving" @click="resetModule(scope.row)">恢复继承</el-button>
            </template>            </el-table-column>
          </el-table>
          </template>
        </div>
      </template>
    </el-card>
    <el-dialog title="模块权限配置" :visible.sync="dialog" :close-on-click-modal="false" :before-close="closeDialog">
      <el-form label-width="110px">
        <el-form-item label="范围">{{ draft.scopeType === 'TYPE' ? '类型默认' : '教材模块 ' + draft.scopeKey }}</el-form-item>
        <el-form-item label="模块归类">
          <el-select v-model="draft.moduleCode" :disabled="saving || !!expected || draft.scopeType === 'TYPE'">
            <el-option v-for="item in catalogTypes" :key="item.code" :label="item.name" :value="item.code" />
          </el-select>
        </el-form-item>
        <el-form-item label="权限模式">
          <el-select v-model="draft.accessMode" :disabled="saving" placeholder="请明确选择权限" @change="changeMode">
            <el-option v-if="draft.scopeType === 'MODULE'" label="继承类型默认" value="INHERIT" />
            <el-option label="完全免费" value="FREE" /><el-option label="需要激活教材" value="BOOK" /><el-option label="需要单独兑换模块" value="MODULE" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="draft.scopeType === 'TYPE'" label="允许教材例外">
          <el-switch v-model="draft.enforced" :active-value="0" :inactive-value="1" :disabled="saving" />
          <p>开启后，具体教材模块的例外优先；关闭后，此类型的全部模块统一使用类型规则。</p>
        </el-form-item>
        <el-form-item label="允许试用"><el-switch v-model="draft.trialEnabled" :active-value="1" :inactive-value="0" :disabled="saving || draft.accessMode === 'FREE' || draft.accessMode === 'INHERIT'" /></el-form-item>
        <el-form-item label="适用版本">
          <el-select v-model="draft.v1Effect" :disabled="saving || draft.accessMode === 'INHERIT'">
            <el-option label="全部版本执行此规则" value="ENFORCE" />
            <el-option v-if="platform" label="仅新版采用，旧版保持原判断" value="KEEP" />
            <el-option v-if="platform && draft.accessMode === 'FREE'" label="新版采用，旧版仅扩展免费" value="FREE_ONLY" />
          </el-select>
        </el-form-item>
        <p>免费不改变整本教材的激活状态。试用仅开放已有试用标记的资源；微剧场视频当前没有试用标记。</p>
      </el-form>
      <span slot="footer"><el-button :disabled="saving" @click="dialog = false">取消</el-button><el-button type="primary" :loading="saving" @click="save">保存</el-button></span>
    </el-dialog>
  </div>
</template>
<script>
/**
 * 界面只编辑／预览数据库规则，不按小程序编号写死免费。
 * 可见范围和 editable 来自后端身份授权；前端按钮状态不构成安全边界。
 */
import { moduleAccessAdminEnabled, getAccessTypes, getAccessMinis, getAccessState, saveAccessRule, resetAccessException } from '@/api/moduleAccess';
// 草稿与 expected 分别深拷贝，避免表单编辑顺带修改用于并发校验的旧快照。
const copy = value => value ? JSON.parse(JSON.stringify(value)) : null;
export default {
  data() {
    return { enabled: moduleAccessAdminEnabled, minis: [], miniid: null, bookid: null, books: [], rules: [], modules: [],
      catalogTypes: [], editable: false, platform: false, denied: false, loading: false, saving: false, sequence: 0, dialog: false, draft: {}, expected: null };
  },
  computed: {
    typeRows() {
      const codes = this.catalogTypes.length ? this.catalogTypes.map(item => item.code) : [];
      return codes.map(code => ({ code, rule: this.rules.find(rule => rule.scopeType === 'TYPE' && rule.scopeKey === code && rule.isValid === 1) }));
    }
  },
  async created() {
    if (!this.enabled) return;
    try {
      const catalog = await getAccessTypes();
      this.catalogTypes = catalog.types || [];
      this.minis = await getAccessMinis();
      const requested = this.$route.query.miniid;
      const preferred = Number(requested);
      if (requested && this.minis.some(mini => Number(mini.id) === preferred)) {
        this.miniid = preferred; this.bookid = Number(this.$route.query.bookid) || null;
      } else if (requested) {
        // 指定了无权管理的小程序时，不改选到自己唯一可管理的程序
        this.denied = true;
      } else if (this.minis.length === 1) this.miniid = this.minis[0].id;
      if (this.miniid) await this.loadState();
    } catch (error) { this.error(error); }
  },
  // 离开页面后令正在返回的预览过期，避免旧请求写入已销毁页面。
  beforeDestroy() { this.sequence++; },
  methods: {
    typeName(code) {
      const item = this.catalogTypes.find(row => row.code === code);
      return item ? item.name : (code || '当前服务尚不支持');
    },
    modeName(mode) { return { FREE: '完全免费', BOOK: '激活教材', MODULE: '单独兑换模块', INHERIT: '继承默认' }[mode] || mode; },
    effectName(effect) { return { ENFORCE: '全部版本', KEEP: '仅新版，旧版保持原判断', FREE_ONLY: '旧版仅扩展免费' }[effect] || effect; },
    sourceName(source) { return { ENFORCED_TYPE: '类型规则（不允许例外）', MODULE_RULE: '本教材模块例外', TYPE_DEFAULT: '类型默认', BOOK_DEFAULT: '教材默认' }[source] || source; },
    error(error) { this.$message.error((error.response && error.response.data && error.response.data.message) || error.message || '请求失败'); },
    moduleRule(id) { return this.rules.find(rule => rule.scopeType === 'MODULE' && rule.scopeKey === String(id)); },
    hasException(id) { const rule = this.moduleRule(id); return !!rule && rule.accessMode !== 'INHERIT'; },
    async changeMini() { this.bookid = null; this.books = []; this.dialog = false; await this.loadState(); },
    // 每次加载清空旧预览并递增序号；只接收当前小程序／教材的最新响应。
    async loadState() {
      const current = ++this.sequence; this.rules = []; this.modules = []; this.editable = false;
      if (!this.miniid) return;
      this.loading = true;
      try {
        const state = await getAccessState(this.miniid, this.bookid);
        if (current !== this.sequence) return;
        this.books = state.books; this.rules = state.rules; this.modules = state.modules;
        this.editable = state.editable; this.platform = state.platform;
      } catch (error) { if (current === this.sequence) this.error(error); }
      finally { if (current === this.sequence) this.loading = false; }
    },
    // 新归类行默认 INHERIT；类型模式要求明确选择。enforced=0 允许教材例外，不代表免费。
    baseRule(scope, key, code) { return { miniid: this.miniid, scopeType: scope, scopeKey: key, moduleCode: code,
      accessMode: scope === 'MODULE' ? 'INHERIT' : '', trialEnabled: 0, enforced: 0, v1Effect: 'ENFORCE', isValid: 1 }; },
    editType(row) { this.expected = copy(row.rule); this.draft = copy(row.rule) || this.baseRule('TYPE', row.code, row.code); this.dialog = true; },
    editModule(row) { this.expected = copy(this.moduleRule(row.id)); this.draft = copy(this.expected) || this.baseRule('MODULE', String(row.id), ''); this.dialog = true; },
    // 从 FREE 转收费时 FREE_ONLY 不再合法，改为 ENFORCE；服务端仍独立校验此组合。
    changeMode(mode) { if (mode !== 'FREE' && this.draft.v1Effect === 'FREE_ONLY') this.draft.v1Effect = 'ENFORCE'; },
    closeDialog(done) { if (!this.saving) done(); },
    // 保存拟修改值及原 expected，服务器返回冲突时要求刷新，不覆盖其他管理员修改。
    async save() {
      if (!this.draft.moduleCode || !this.draft.accessMode) return this.$message.error('请选择模块归类和权限模式');
      this.saving = true;
      try {
        const rule = copy(this.draft);
        if (rule.accessMode === 'INHERIT') { rule.v1Effect = 'KEEP'; rule.trialEnabled = 0; }
        if (rule.accessMode === 'FREE') rule.trialEnabled = 0;
        if (rule.accessMode !== 'FREE' && rule.v1Effect === 'FREE_ONLY') rule.v1Effect = 'ENFORCE';
        await saveAccessRule(rule, this.expected); this.dialog = false; this.$message.success('权限已保存'); await this.loadState();
      } catch (error) { this.error(error); }
      finally { this.saving = false; }
    },
    // 仅取消该模块价格例外并保留稳定归类，不能删除整类规则。
    async resetModule(row) {
      const expected = copy(this.moduleRule(row.id)); if (!expected) return;
      try { await this.$confirm('恢复类型默认权限，并保留该模块的归类？', '恢复继承'); } catch (cancel) { return; }
      this.saving = true;
      try { await resetAccessException(copy(expected), expected); this.$message.success('已恢复继承'); await this.loadState(); }
      catch (error) { this.error(error); } finally { this.saving = false; }
    }
  }
};
</script>
<style scoped>
.module-access { padding: 24px; }
.campus { margin-bottom: 20px; }
p { line-height: 1.7; color: #606266; }
h3 { margin-top: 28px; }
</style>
